import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import _get from 'lodash/get';

import { auth } from '../../utils/sessions';
import { NotSubscribedError } from '../errorPage';
import fullscreen_icon from './assets/toolbar/full-screen.svg';
import download_icon from './assets/toolbar/download.svg';
import filter_icon from './assets/toolbar/clear-filters.svg';
import pause_icon from './assets/toolbar/pause.svg';
import resume_icon from './assets/toolbar/resume.svg';

class Report extends React.Component {
    constructor(props){
        super(props);

        let redirectPath = null;
        let report = null;
        const categoryId = _get(this, 'props.match.params.categoryId', null);
        this.category = this.props.reportCategories.find(cat => cat.id === categoryId);

        const reportId = _get(this, 'props.match.params.reportId', null);
        if(this.category) {
            report = this.category.reports.find(report => report.id === reportId);
        }

        if((!reportId || !report ) && this.category){
            redirectPath = `/category/${this.category.id}`;
        }
        else if(!categoryId || !this.category){
            redirectPath = `/category/${this.props.reportCategories[0].id}`;
        }

        this.state = {report: report, redirect: redirectPath, dataIsPaused: false};

        this.exportCrossTab = this.exportCrossTab.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportData = this.exportData.bind(this);
        this.exportImage = this.exportImage.bind(this);
        this.revertFilters = this.revertFilters.bind(this);
        this.toggleData = this.toggleData.bind(this);
        this.fullScreen = this.fullScreen.bind(this);
    }

    initializeReport(){
        if(this.state.report && this.props.user.memberId) {
            const containerDiv = document.getElementById('tableau-report-' + this.state.report.id);
            const url = this.state.report.url;
            const options = this.state.report.options;
            options.MemberID = this.props.user.memberId;

            this.tableau = new window.tableau.Viz(containerDiv, url, options);
        }
    }

    componentDidMount(){
        auth.extend_or_expire();
        this.initializeReport();
    }

    componentWillReceiveProps(){
        auth.extend_or_expire();
        this.initializeReport();
    }

    exportImage(){
        this.tableau.showExportImageDialog();
    }

    exportPdf(){
        this.tableau.showExportPDFDialog();
    }

    exportCrossTab(){
        this.tableau.showExportCrossTabDialog();
    }

    exportData(){
        this.tableau.showExportDataDialog();
    }

    revertFilters(){
        //clear out all the filters
        this.tableau.revertAllAsync();
        //reset the memberId
        this.tableau.getWorkbook().changeParameterValueAsync('MemberID', this.props.user.memberId);
    }

    toggleData(){
        this.setState({dataIsPaused: !this.state.dataIsPaused});
        this.tableau.toggleAutomaticUpdatesAsync();
    }

    fullScreen(){
        const element = document.getElementById('tableau-report-' + this.state.report.id);

        if (element) {
            if(element.requestFullscreen) {
                element.requestFullscreen();
            } else if(element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if(element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if(element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        }
    }

    renderDataToggleBtn(){
        const buttonText = (this.state.dataIsPaused) ? 'Resume Data' : 'Pause Data';
        const icon = (this.state.dataIsPaused) ? resume_icon : pause_icon;

        return (
            <span>
                <img src={icon} alt="pause"></img> {buttonText}
            </span>
        )
    }

    render(){
        if(!this.props.user.memberId){
            return null;
        }
        else if (this.state.redirect) {
            return <Redirect to={{
                pathname: this.state.redirect
            }}/>
        }
        else if(auth.tab_disabled(this.props.user.ul, this.category.title)){
            return <NotSubscribedError />
        }
        else {
            return (
                <div className="report-container">
                    <div className="report-btn-toolbar text-right">
                        <div className="btn-group">
                            <button className="btn btn-secondary btn-sm report-toolbar-btn mr-1" onClick={this.fullScreen}>
                                <img src={fullscreen_icon} alt="full screen"></img> View Full Screen
                            </button>
                        </div>
                        <div className="btn-group">
                            <button className="btn btn-secondary dropdown-toggle report-toolbar-btn btn-sm mr-1" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <img src={download_icon} alt="download"></img> Download Report
                            </button>
                            <div className="dropdown-menu">
                                <a className="dropdown-item" onClick={this.exportPdf}>PDF</a>
                                <a className="dropdown-item" onClick={this.exportCrossTab}>Cross Tab</a>
                                <a className="dropdown-item" onClick={this.exportData}>Data</a>
                                <a className="dropdown-item" onClick={this.exportImage}>Image</a>
                            </div>
                        </div>

                        <div className="btn-group">
                            <button className="btn btn-secondary report-toolbar-btn btn-sm mr-1" onClick={this.toggleData}>
                                { this.renderDataToggleBtn() }
                            </button>
                        </div>
                        <div className="btn-group">
                            <button className="btn btn-secondary report-toolbar-btn btn-sm mr-1 report-clear-btn" onClick={this.revertFilters}>
                                <img src={filter_icon} alt="clear"></img> Clear All
                            </button>
                        </div>
                    </div>
                    <div className="tableau-report" id={'tableau-report-' + this.state.report.id } ></div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        reportCategories: state.reportCategories
    };
}

export default withRouter(connect(mapStateToProps)(Report));


// WEBPACK FOOTER //
// ./src/components/reports/Report.jsx